const defaultParams =  {
    prompt: 'Are you sure?',
    confirmTxt: 'Yes',
    cancelTxt: 'No',
    description: "Description",
};
import tippy from 'tippy.js';

export function confirmable(node, p = {}) {
    const params = Object.assign({...defaultParams}, p);

    const html = `<div class="confirm-dialog">
        <span> ${params.prompt}</span>
        <span class="btn confirm"> ${params.confirmTxt} </span>
        <span class="btn cancel"> ${params.cancelTxt} </span>
    </div>`;
    const template = document.createElement('template');
    template.innerHTML = html;
    template.content.firstChild.querySelector('.confirm').addEventListener('click', (e) => {
        node.dispatchEvent(new CustomEvent('confirmation', {detail: tip}));
    });
    template.content.firstChild.querySelector('.cancel').addEventListener('click', (e) => {
        node.dispatchEvent(new CustomEvent('cancel', {detail: tip}) );
    });
    const tip = tippy(node, {
        content: template.content.firstChild,
        duration: [500, 0],
        trigger: 'click',
        interactive: true,
        maxWidth: 'none',
        onClickOutside: ()=> node.dispatchEvent(new CustomEvent('clickoutside',  {detail: tip})),
        onShow: () => node.dispatchEvent(new CustomEvent('show', {detail: tip})),
    });

    return {
        destroy: () => tip.destroy(),
    };
}

export function tooltip(node, params = {delay: [400, 0]}) {
    const custom = params.content;
    const title = node.title;
    const label = node.getAttribute("aria-label");
    const content = custom || title || label;
  
    if (!label) node.setAttribute("aria-label", content);
    
    // clear to disable default tooltip
    node.title = "";
    // Support any of the Tippy props by forwarding all "params":
    const tip = tippy(node, { content, ...params });
  
    return {
      update: (newParams) => tip.setProps({ content, ...newParams }),
      destroy: () => tip.destroy(),
    };
  };
  